import React, { createContext, useContext, useState, useEffect } from 'react';

const SecurityContext = createContext();

export const useSecurity = () => {
  const context = useContext(SecurityContext);
  if (context === undefined) {
    throw new Error('useSecurity must be used within a SecurityProvider');
  }
  return context;
};

export const SecurityProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [showSecurityModal, setShowSecurityModal] = useState(false);

  // Get security pass from environment variable or use default for testing
  const getSecurityPass = () => {
    return process.env.REACT_APP_SECURITY_PASS || 'hexas123';
  };

  const verifySecurity = () => {
    const encodedPass = localStorage.getItem('security_pass');
    
    if (!encodedPass) {
      setShowSecurityModal(true);
      return;
    }

    try {
      // Decode the stored security code
      const decryptedPass = atob(encodedPass);

      // Check if the decoded code matches the environment variable
      if (decryptedPass === getSecurityPass()) {
        setIsAuthenticated(true);
        setShowSecurityModal(false);
      } else {
        // Invalid stored code, show modal
        localStorage.removeItem('security_pass');
        setShowSecurityModal(true);
      }
    } catch (error) {
      // Decoding failed, show modal
      localStorage.removeItem('security_pass');
      setShowSecurityModal(true);
    }
  };

  const handleSecuritySubmit = (success) => {
    if (success) {
      setIsAuthenticated(true);
      setShowSecurityModal(false);
    }
  };

  useEffect(() => {
    verifySecurity();
  }, []);

  const value = {
    isAuthenticated,
    showSecurityModal,
    verifySecurity,
    handleSecuritySubmit,
  };

  return (
    <SecurityContext.Provider value={value}>
      {children}
    </SecurityContext.Provider>
  );
}; 